function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { saveAs } from 'file-saver';
import DocumentAuditEvent from '../api/service/DocumentAuditEvent';
import { getAsyncPath, postPath, putPath } from '../api/service/Documents';
import { assertEquals } from '../common/assert';
import { document as documentMapper } from '../mappers/dto-to-model';
import * as modelMapper from '../mappers/dto-to-model';
import { projectOrFolderType } from '../mappers/model-to-dto';
import * as dtoMapper from '../mappers/model-to-dto';
import { ItemKey, ItemType, toApiContainerType } from '../models';
import { clone } from '../models/item';
import ItemService from './item-service';
var DocumentService = /*#__PURE__*/function (_ItemService) {
  function DocumentService(http) {
    var _this;
    _classCallCheck(this, DocumentService);
    _this = _callSuper(this, DocumentService, [http]);
    _this.documentAuditEventService = void 0;
    _this.documentAuditEventService = new DocumentAuditEvent(_this.http);
    return _this;
  }
  _inherits(DocumentService, _ItemService);
  return _createClass(DocumentService, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(key, container) {
        var apiContainerType, response;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              assertEquals(key.type, ItemType.Document, 'documentService.get called with non-document', true, key);
              apiContainerType = projectOrFolderType(container.type);
              _context.next = 4;
              return this.apiDocumentsService.getMetadataAsync(apiContainerType, container.id, key.id, {
                LoadItemMetadata: false
              });
            case 4:
              response = _context.sent;
              return _context.abrupt("return", documentMapper(response.body));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
    /**
     * Fetches byte array of the document
     * @param key - document Id
     * @param container - container Id
     * @param convertToPdf - whether or not `application/pdf` should be passed in `Accept` header; defaulted to `false`
     * @param options - any optional parameters to be passed into HttpConfig
     * @returns - document ArrayBuffer
     */
  }, {
    key: "getDocumentArrayBuffer",
    value: (function () {
      var _getDocumentArrayBuffer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(key, container) {
        var convertToPdf,
          options,
          apiContainerType,
          config,
          response,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              convertToPdf = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
              options = _args2.length > 3 ? _args2[3] : undefined;
              assertEquals(key.type, ItemType.Document, 'documentService.getDocumentArrayBuffer called with non-document', true, key);
              apiContainerType = toApiContainerType(container.type);
              config = {
                method: 'GET',
                url: getAsyncPath(apiContainerType, container.id, key.id),
                responseType: 'arraybuffer',
                headers: {
                  Accept: convertToPdf ? 'application/pdf' : '*/*',
                  'Content-Type': '*/*'
                },
                customData: options
              };
              _context2.next = 7;
              return this.http(config);
            case 7:
              response = _context2.sent;
              return _context2.abrupt("return", response.body);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getDocumentArrayBuffer(_x3, _x4) {
        return _getDocumentArrayBuffer.apply(this, arguments);
      }
      return getDocumentArrayBuffer;
    }())
  }, {
    key: "fetchDocumentArrayBuffer",
    value: function () {
      var _fetchDocumentArrayBuffer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(key, container, convertToPdf) {
        var apiContainerType, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              assertEquals(key.type, ItemType.Document, 'documentService.fetchDocumentArrayBuffer called with non-document', true, key);
              apiContainerType = toApiContainerType(container.type);
              _context3.next = 4;
              return fetch(getAsyncPath(apiContainerType, container.id, key.id), {
                method: 'GET',
                headers: {
                  Accept: convertToPdf ? 'application/pdf' : '*/*',
                  'Content-Type': '*/*'
                }
              });
            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.arrayBuffer());
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function fetchDocumentArrayBuffer(_x5, _x6, _x7) {
        return _fetchDocumentArrayBuffer.apply(this, arguments);
      }
      return fetchDocumentArrayBuffer;
    }()
  }, {
    key: "saveDocument",
    value: function () {
      var _saveDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(key, container) {
        var documentBuffer, document, blob;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              assertEquals(key.type, ItemType.Document, 'documentService.saveDocument called with non-document', true, key);
              _context4.next = 3;
              return this.getDocumentArrayBuffer(key, container);
            case 3:
              documentBuffer = _context4.sent;
              _context4.next = 6;
              return this.get(key, container);
            case 6:
              document = _context4.sent;
              blob = new Blob([documentBuffer], {
                type: document.mimeType
              });
              saveAs(blob, document.name);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function saveDocument(_x8, _x9) {
        return _saveDocument.apply(this, arguments);
      }
      return saveDocument;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(container, file) {
        var url, formData, response, responseBody;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // call directly as swagger doesn't generate the needed post
              url = postPath(toApiContainerType(container.type), container.id);
              formData = new FormData();
              formData.append('file[]', file);
              _context5.next = 5;
              return this.http({
                url: url,
                method: 'POST',
                body: formData
              });
            case 5:
              response = _context5.sent;
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              responseBody = response.body;
              return _context5.abrupt("return", documentMapper(responseBody.data));
            case 8:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function post(_x10, _x11) {
        return _post.apply(this, arguments);
      }
      return post;
    }() // eslint-disable-next-line max-params
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(container, documentId, documentFile, annotationsFile, initiator) {
        var putParams, url, formData, response, responseBody;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              // call directly as swagger doesn't generate the needed put
              url = putPath(toApiContainerType(container.type), container.id, documentId);
              formData = new FormData();
              formData.append('file[]', documentFile);
              if (annotationsFile) {
                formData.append('annotations[]', annotationsFile);
              }
              if (initiator) {
                putParams = {
                  initiator: initiator
                };
              }
              _context6.next = 7;
              return this.http({
                url: url,
                method: 'PUT',
                body: formData,
                params: putParams
              });
            case 7:
              response = _context6.sent;
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              responseBody = response.body;
              return _context6.abrupt("return", documentMapper(responseBody.data));
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function put(_x12, _x13, _x14, _x15, _x16) {
        return _put.apply(this, arguments);
      }
      return put;
    }() // eslint-disable-next-line max-params
  }, {
    key: "putUsingFetch",
    value: function () {
      var _putUsingFetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(container, documentId, documentFile, annotationsFile, initiator) {
        var putParams, url, formData, params, response, responseBody;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              // call directly as swagger doesn't generate the needed put
              url = putPath(toApiContainerType(container.type), container.id, documentId);
              formData = new FormData();
              formData.append('file[]', documentFile);
              if (annotationsFile) {
                formData.append('annotations[]', annotationsFile);
              }
              if (initiator) {
                putParams = {
                  initiator: initiator
                };
              }
              params = new URLSearchParams(putParams).toString();
              params && (params = '?' + params);
              _context7.next = 9;
              return fetch(url + params, {
                method: 'PUT',
                body: formData
              });
            case 9:
              response = _context7.sent;
              _context7.next = 12;
              return response.json();
            case 12:
              responseBody = _context7.sent;
              return _context7.abrupt("return", documentMapper(responseBody.data));
            case 14:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function putUsingFetch(_x17, _x18, _x19, _x20, _x21) {
        return _putUsingFetch.apply(this, arguments);
      }
      return putUsingFetch;
    }()
  }, {
    key: "moveDocument",
    value: function () {
      var _moveDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(destination, doc, renameOnConflict) {
        var name;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              name = doc.name;
              _context8.next = 3;
              return this.exists(destination, name);
            case 3:
              if (!_context8.sent) {
                _context8.next = 9;
                break;
              }
              if (renameOnConflict) {
                _context8.next = 6;
                break;
              }
              throw new Error('File name is not available');
            case 6:
              _context8.next = 8;
              return this.getUniqueName(destination, name);
            case 8:
              name = _context8.sent;
            case 9:
              _context8.next = 11;
              return this.apiDocumentsV1Service.putMoveAsync(doc.id, {
                name: name,
                containerId: destination.id
              });
            case 11:
              return _context8.abrupt("return", clone(doc, {
                name: name,
                parent: destination
              }));
            case 12:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function moveDocument(_x22, _x23, _x24) {
        return _moveDocument.apply(this, arguments);
      }
      return moveDocument;
    }()
  }, {
    key: "getUrl",
    value: function getUrl(key, container) {
      return getAsyncPath(toApiContainerType(container.type), container.id, key.id);
    }
  }, {
    key: "exists",
    value: function () {
      var _exists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(container, filename) {
        var response, result;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (filename.trim()) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return", false);
            case 2:
              _context9.next = 4;
              return this.apiDocumentsService.documentExistsAsync(projectOrFolderType(container.type), container.id, [filename]);
            case 4:
              response = _context9.sent;
              result = response.body[0];
              return _context9.abrupt("return", !!result.exists && new ItemKey(result.id, ItemType.Document));
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function exists(_x25, _x26) {
        return _exists.apply(this, arguments);
      }
      return exists;
    }()
  }, {
    key: "copyDocument",
    value: function () {
      var _copyDocument = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(document, target) {
        var name, dto, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              name = document.name;
              dto = dtoMapper.copyDocument(name, target);
              _context10.next = 4;
              return this.apiDocumentsService.copyAsync(dtoMapper.projectOrFolderType(document.parent.type), document.parent.id, document.id, {}, dto);
            case 4:
              response = _context10.sent;
              return _context10.abrupt("return", documentMapper(response.body));
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function copyDocument(_x27, _x28) {
        return _copyDocument.apply(this, arguments);
      }
      return copyDocument;
    }()
    /**
     * Creates the url to use when attempting to open documents in Onvio Link
     *
     * @param document - The document being opened
     * @param userId - the blue ID of the current user
     * @param contactId - the contact ID of the current user
     *
     * @returns The url formatted to open in Onvio Link
     */
  }, {
    key: "getOnvioLinkUrl",
    value: function getOnvioLinkUrl(document, userId, contactId) {
      var containerType = projectOrFolderType(document.parent.type);
      var url = getAsyncPath(containerType, document.parent.id, document.id);
      var openDocumentRequest = {
        url: url,
        name: document.name,
        userId: userId,
        contactId: contactId
      };
      var openDocumentRequestJson = JSON.stringify(openDocumentRequest);
      return 'onvio:' + btoa(unescape(encodeURIComponent(openDocumentRequestJson)));
    }
  }, {
    key: "getDocumentAuditEventsAsync",
    value: function () {
      var _getDocumentAuditEventsAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(itemId, page, documentEventTypes) {
        var modifiedBy,
          startActivityDate,
          endActivityDate,
          params,
          response,
          _args11 = arguments;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              modifiedBy = _args11.length > 3 && _args11[3] !== undefined ? _args11[3] : [];
              startActivityDate = _args11.length > 4 && _args11[4] !== undefined ? _args11[4] : '';
              endActivityDate = _args11.length > 5 && _args11[5] !== undefined ? _args11[5] : '';
              params = _objectSpread(_objectSpread({
                page: page.pageNumber,
                pageSize: page.itemCount,
                documentEventTypes: dtoMapper.documentEventTypes(documentEventTypes),
                modifiedBy: modifiedBy
              }, startActivityDate && startActivityDate !== '' && {
                startActivityDate: startActivityDate
              }), endActivityDate && endActivityDate !== '' && {
                endActivityDate: endActivityDate
              });
              _context11.next = 6;
              return this.documentAuditEventService.getDocumentAuditEventsAsync(itemId, params);
            case 6:
              response = _context11.sent;
              return _context11.abrupt("return", modelMapper.documentAuditEvents(response.body));
            case 8:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getDocumentAuditEventsAsync(_x29, _x30, _x31) {
        return _getDocumentAuditEventsAsync.apply(this, arguments);
      }
      return getDocumentAuditEventsAsync;
    }()
  }, {
    key: "getUniqueName",
    value: function () {
      var _getUniqueName = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(container, name) {
        var counter,
          newName,
          used,
          _args12 = arguments;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              counter = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : 1;
              newName = "".concat(name, " (").concat(counter, ")");
              _context12.next = 4;
              return this.exists(container, name);
            case 4:
              used = _context12.sent;
              if (used) {
                _context12.next = 7;
                break;
              }
              return _context12.abrupt("return", newName);
            case 7:
              return _context12.abrupt("return", this.getUniqueName(container, name, counter + 1));
            case 8:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getUniqueName(_x32, _x33) {
        return _getUniqueName.apply(this, arguments);
      }
      return getUniqueName;
    }()
  }]);
}(ItemService);
export { DocumentService as default };
